// extracted by mini-css-extract-plugin
export var black = "headline-module--black--4025c";
export var center = "headline-module--center--2f6bf";
export var centerMobile = "headline-module--centerMobile--d9f75";
export var h1 = "headline-module--h1--ce75d";
export var h2 = "headline-module--h2--ef26a";
export var h3 = "headline-module--h3--2d9fa";
export var h4 = "headline-module--h4--86809";
export var h5 = "headline-module--h5--60373";
export var h6 = "headline-module--h6--060f6";
export var headline = "headline-module--headline--19b21";
export var primary = "headline-module--primary--4680a";
export var secondary = "headline-module--secondary--564bc";
export var tertiary = "headline-module--tertiary--81bd0";
export var text = "headline-module--text--3f58d";
export var white = "headline-module--white--5fc59";